// src/components/JobVid.js
import React, { useState } from "react";
import "./JobVid.css";

// Import images from your assets folder. (Make sure file names match your project.)
import merchandiseImg from "../assets/Job_btn/merchandise.png";
import custodialImg from "../assets/Job_btn/custodial.png";
import attractionsImg from "../assets/Job_btn/attractions.png";
import lifeguardImg from "../assets/Job_btn/lifeguard.png";
import quicksvImg from "../assets/Job_btn/quicksv.png";
import moreImg from "../assets/Job_btn/more.png";
import disneyPlaceImg from "../assets/4-parks-1-day-Disney 1.png";

const JobVid = () => {
  // State to hold the currently selected video URL.
  const [videoUrl, setVideoUrl] = useState(null);

  // Opens the modal by setting the video URL.
  const openModal = (url) => {
    setVideoUrl(url);
  };

  // Closes the modal.
  const closeModal = () => {
    setVideoUrl(null);
  };

  return (
    <div className="jobvid-container">
      {/* Job Position Section */}
      <div className="job-position-container">
        <div className="job-position-head">
          <div className="job-potition-text">
            <h2>ไปดูงานแต่ละตำแหน่งกัน!</h2>
          </div>
        </div>
        <div className="job-position-mid">
          <div className="job-position-btn-container">
            <div className="job-btn-line1">
              <a
                href="#!"
                className="image-button"
                onClick={() =>
                  openModal("https://www.youtube.com/embed/wpkkIPXYfzE?autoplay=1")
                }
              >
                <img src={merchandiseImg} alt="merchandise" />
              </a>
              <a
                href="#!"
                className="image-button"
                onClick={() =>
                  openModal("https://www.youtube.com/embed/HcaWWMg0JJE?autoplay=1")
                }
              >
                <img src={custodialImg} alt="custodial" />
              </a>
              <a
                href="#!"
                className="image-button"
                onClick={() =>
                  openModal("https://www.youtube.com/embed/kimr7n5Qh7E?autoplay=1")
                }
              >
                <img src={attractionsImg} alt="attractions" />
              </a>
            </div>
            <div className="job-btn-line2">
              <a
                href="#!"
                className="image-button"
                onClick={() =>
                  openModal("https://www.youtube.com/embed/wJkuae5A3PU?autoplay=1")
                }
              >
                <img src={lifeguardImg} alt="lifeguard" />
              </a>
              <a
                href="#!"
                className="image-button"
                onClick={() =>
                  openModal("https://www.youtube.com/embed/hzkflsou40M?autoplay=1")
                }
              >
                <img src={quicksvImg} alt="quicksv" />
              </a>
              <a
                href="#!"
                className="image-button"
                onClick={() =>
                  openModal("https://www.youtube.com/embed/EfpT0SB1zks?autoplay=1")
                }
              >
                <img src={moreImg} alt="more" />
              </a>
            </div>
          </div>
          {/* Modal container (renders only when a videoUrl is set) */}
          {videoUrl && (
            <div className="modal" onClick={closeModal}>
              <div
                id="modalContent"
                onClick={(e) => e.stopPropagation()}
              >
                <iframe
                  width="1060"
                  height="815"
                  src={videoUrl}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          )}
        </div>
        <div className="job-position-bottom"></div>
      </div>
      {/* Place picture container */}
      <div className="place-picturecontainer">
        <img src={disneyPlaceImg} alt="disney-place-picture" />
      </div>
    </div>
  );
};

export default JobVid;
